export const RouteSegments = {
  LOGOUT: "logout",
} as const;

export const AppRoutes = {
  LOGOUT: `/${RouteSegments.LOGOUT}`,
} as const;

export const HeaderMenuLabels = {
  USER_MANAGEMENT: "User Management",
  LOGOUT: "Log out",
} as const;

export const LOGOUT_SUCCESS_MESSAGE =
  "You have been successfully logged out of the application.";